export const formatValue = (value, precision = 1) => {
	if (!Number.isFinite(value)) {
		return '';
	}
	const digits = value
		? Math.max(1, Math.floor(Math.log10(Math.abs(value)) + 1))
		: 1;

	return `${value.toFixed(Math.max(0, precision - digits))}`;
};
